@defer (when tickets) {
<div class="banner">
  @for (ticket of tickets; track ticket) {
    <div class="ticket">
      <div>&nbsp;<i class="fa fa-fw fa-warning"></i> {{ ticket.title }}</div>
      <div [routerLink]="['/tickets', ticket.id]">Learn more</div>
    </div>
  }
</div>
} @placeholder {
<i class="mdi mdi-spin-x2 mdi-loading"></i>
}
